var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWifi = function SvgIconWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 49"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Icon_Wifi_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.8,
    d: "M33.603 29.27a2.5 2.5 0 0 1-1.713-.677c-3.398-3.184-7.01-4.185-10.735-2.98-2.85.92-4.751 2.79-4.77 2.809a2.506 2.506 0 0 1-3.564-3.524c.11-.111 2.747-2.746 6.791-4.054 3.845-1.243 9.688-1.542 15.703 4.092a2.506 2.506 0 0 1-1.712 4.334",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.6,
    d: "M7.922 22.232a2.504 2.504 0 0 1-1.654-4.389c9.89-8.682 19.132-8.185 25.143-6.24 6.425 2.08 10.494 6.2 10.664 6.373a2.505 2.505 0 0 1-3.581 3.504c-.07-.07-3.525-3.509-8.8-5.165-6.886-2.162-13.656-.38-20.12 5.294a2.5 2.5 0 0 1-1.652.623",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.103,
    cy: 35.135,
    r: 3.4,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Icon_Wifi_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 21.104 24.102 0l21.102 21.103-21.102 21.102z"
  })))));
};
export default SvgIconWifi;